import toggleMainSidebar from './toggleMainSidebar';

export default toggleMainSidebar;
